/**
 * Ryan O'Dowd
 * 2023-01-24
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    authFormContainerWrapper: {
      flex: 1,
    },
    authFormContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
    },
    inputsWrapper: {
      width: '100%',
      minWidth: 300, // @TODO: shouldn't need this
      gap: 8,
    },
    guestConfirmationText: {
      color: colors.dialogText,
    },
    formText: {
      flexWrap: 'wrap',
      textAlign: 'center',
      fontSize: globalScale * 16,
      color: colors.white,
      marginBottom: globalScale * 24,
    },
    buttonLoadingWrapper: {
      flexDirection: 'row',
    },
    submitButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    loadingIndicator: {
      display: 'flex',
      justifySelf: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 8,
    },
    successText:{
      color: colors.accent,
    },
  };
};

export default getStyles;
